import React, { Fragment, useEffect, useState } from "react";
import lockIcon from "../../images/lock.png";
import userCheck from "../../images/user-check.png";
import userGroup from "../../images/users-group.png";
import userEdit from "../../images/user-edit.png";
import user from "../../images/user.png";
import { Link, useLocation } from "react-router-dom";
import { VideoLink } from "../videoLink";
import { Sidebar } from "../sidebar";
import { Person } from "../person";
import { LoginForm } from "../loginForm";
import { useDispatch } from "react-redux";
import { clearErrors } from "../../redux/slices/auth";
import Form from "react-bootstrap/Form";
import { ServerURL } from "../../redux/Server";
import { Privacy } from "../privacy";

export const Login = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [loginType, setLoginType] = useState("default");
  const [loginError, setLoginError] = useState("");

  useEffect(() => {
    if (loginType === "default") {
      dispatch(clearErrors());
    }
  }, [loginType, dispatch]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const AuthError = params.get("message");
    setLoginError(AuthError);
    const pathName = window.location.pathname;
    const redirectTo = pathName.replace(`?message="Authentication Faild"`, "");
    window.history.replaceState(null, "", redirectTo);
    localStorage.removeItem("nonCommitteeToken");
    localStorage.removeItem("nonCommitteeTokenExp");
  }, [location]);

  const handlePrivacy = () => {
    setLoginType("privacy");
  };

  return (
    <div className="login">
      <Sidebar setLoginType={setLoginType} />
      <div className="login-form">
        {loginType === "default" ? null : (
          <div className="back-home-container">
            <button
              className="btn back-home"
              onClick={() => setLoginType("default")}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                <path d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z" />
              </svg>
              الرئيسية
            </button>
          </div>
        )}
        <div className="login-form_container">
          <header>
            {loginType !== "privacy" && <img src={lockIcon} alt="login" />}

            {loginType === "privacy" ? (
              <h1>سياسة الخصوصية</h1>
            ) : loginType && loginType === "NON_RESIDENT" ? (
              <h1>تسجيل الدخول - غير مقيم</h1>
            ) : loginType &&
              (loginType === "CITIZEN" || loginType === "RESIDENT") ? (
              <h1>تسجيل الدخول - مواطن / مقيم</h1>
            ) : loginType && loginType === "LEGAL_AGENT" ? (
              <h1>تسجيل الدخول - وكيل شرعي</h1>
            ) : loginType && loginType === "LEGAL_REPRSENTATIVE" ? (
              <h1>تسجيل الدخول - ممثل نظامي</h1>
            ) : (
              <h1>تسجيل الدخول</h1>
            )}
            {loginError ? (
              <Form.Control.Feedback
                type="invalid"
                className={
                  loginError
                    ? "invalid-feedback d-block mb-3 text-center"
                    : "invalid-feedback"
                }>
                فشل تسجيل الدخول
              </Form.Control.Feedback>
            ) : null}
          </header>
          {loginType && loginType === "default" ? (
            <Fragment>
              <div className="login-type">
                <a href={`${ServerURL}/NafathRestApi/saml/sso`}>
                  <span>
                    <img src={userCheck} alt="مكلف" />
                  </span>
                  <section className="link-content">
                    <header>
                      مكلف
                      <p>(شركة - مؤسسة - فرد)</p>
                    </header>
                    <p>مسجل لدى الهيئة "يوجد رقم مميز"</p>
                  </section>
                </a>
                <Link onClick={() => setLoginType("LEGAL_AGENT")}>
                  <span>
                    <img src={userGroup} alt="وكيل شرعي" />
                  </span>
                  <section className="link-content">
                    <header>وكيل شرعي</header>
                    <p>"بموجب وكالة شرعية، ترخيص محاماة"</p>
                  </section>
                </Link>
                <Link onClick={() => setLoginType("LEGAL_REPRSENTATIVE")}>
                  <span>
                    <img src={userEdit} alt="ممثل نظامي" />
                  </span>
                  <section className="link-content">
                    <header>ممثل نظامي</header>
                    <p>"بموجب عقد التأسيس، ترخيص تمثيل الشخصية المعنوية"</p>
                  </section>
                </Link>
                <Link onClick={() => setLoginType("person")}>
                  <span>
                    <img src={user} alt="فرد" />
                  </span>
                  <section className="link-content">
                    <header>فرد</header>
                    <p>غير مسجل لدى الهيئة "لا يوجد رقم مميز"</p>
                  </section>
                </Link>
              </div>
              <div className="nonCommittee-content">
                <h2>تعليمات هامة</h2>
                <p>
                  “يتعين تقديم اعتراض ابتداءً لدى هيئة الزكاة والضريبة والجمارك
                  قبل التقدم بدعوى تظلم أمام الأمانة العامة للجان الزكوية
                  والضريبية والجمركية في حال كانت الدعوى مقامة ضد هيئة الزكاة
                  والضريبة والجمارك وفقا لما نصت عليه الأنظمة والقواعد ذات
                  العلاقة”
                </p>
                <p>
                  “لا يتوجب رفع اعتراض لدى هيئة الزكاة والضريبة والجمارك لدعاوى
                  استرداد ضريبة القيمة المضافة للتوريدات العقارية للأفراد”
                </p>
              </div>
            </Fragment>
          ) : loginType && loginType === "person" ? (
            <Person setLoginType={setLoginType} />
          ) : loginType && loginType === "privacy" ? (
            <Privacy />
          ) : (
            <LoginForm loginType={loginType} />
          )}

          <VideoLink customClass="mt-5 mb-4" />
          {loginType !== "privacy" && (
            <button className="video-link" onClick={handlePrivacy}>
              سياسة الخصوصية
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
